import { useEffect, useState } from 'react';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';
import { dispatch } from '../../../store';
import { addUserProfile } from '../../../store/slices/user-profile.slice';

const useHttpGetUserGeneralInformationOnMount = (userSub: string) => {
    const navigate = useNavigate();
    const { t } = useTranslation('newNotifications');
    const toastHandler = useContainer(ToastStateHandler);
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isReady, setIsReady] = useState(false);

    const fetchUserProfile = () => {
        const { exec, abort } = acsApi.getUserProfileData({
            params: { userSub },
            onSuccess: res => {
                dispatch(addUserProfile(res.body));
            },
            onError: () => {
                toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong'));
                navigate('/not-found');
            },
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(() => {
        return fetchUserProfile();
    }, [userSub]);

    return { isReady, refetch: fetchUserProfile };
};

export default useHttpGetUserGeneralInformationOnMount;
